import { posthog, isPostHogEnabled } from "./posthog";

export const AnalyticsEvents = {
  // Auth / account
  SignedUp: "signed_up",
  SignedIn: "signed_in",
  SignedOut: "signed_out",
  // Organization
  OrganizationCreated: "organization_created",
  OrganizationSwitched: "organization_switched",
  InvitationAccepted: "invitation_accepted",
  InvitationRejected: "invitation_rejected",
  // Projects
  ProjectCreated: "project_created",
  ProjectViewed: "project_viewed",
  // Templates
  TemplateCreated: "template_created",
  TemplateEdited: "template_edited",
  TemplateTranslated: "template_translated",
  TemplateDuplicated: "template_duplicated",
  TemplateDeleted: "template_deleted",
  TemplateRestored: "template_version_restored",
  TemplateMetadataUpdated: "template_metadata_updated",
  ReviewSubmitted: "review_submitted",
  ReviewDecided: "review_decided",
  TemplatePublished: "template_published",
  TestSend: "template_test_send",
  // Sending / setup
  DeliverySettingsUpdated: "delivery_settings_updated",
  ConnectionCreated: "connection_created",
  ConnectionRemoved: "connection_removed",
  DomainAdded: "domain_added",
  DomainVerified: "domain_verified",
  DomainRemoved: "domain_removed",
  SuppressionRemoved: "suppression_removed",
  // API / billing / media
  ApiKeyCreated: "api_key_created",
  ApiKeyUpdated: "api_key_updated",
  ApiKeyDeleted: "api_key_deleted",
  CheckoutStarted: "checkout_started",
  BillingPortalOpened: "billing_portal_opened",
  MediaUploaded: "media_uploaded",
  MediaDeleted: "media_deleted",
  // Discovery
  LogsViewed: "logs_viewed",
  VirtualInboxViewed: "virtual_inbox_viewed",
  PageViewed: "$pageview",
} as const;

export type AnalyticsEvent = (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];

type EventProps = Record<string, string | number | boolean | null | undefined>;

export function track(event: AnalyticsEvent | string, props?: EventProps) {
  if (!isPostHogEnabled()) return;
  posthog.capture(event, props);
}

export function getFeatureFlag(key: string): string | boolean | undefined {
  if (!isPostHogEnabled()) return undefined;
  return posthog.getFeatureFlag(key);
}
